import React, { useRef, useEffect, useState, forwardRef } from "react";
import {
  useJsApiLoader,
} from "@react-google-maps/api";
import { useMemo } from "react";
import { getMeters } from "@/helpers/common";
import { getBoundaryCoordinates } from "@/services/wantAdService";
import Loader from "@/components/Common/Loader";
import MapBoxComponent from "@/components/Common/MapboxComponent";

const WantAdGoogleMap = forwardRef(
  (
    {
      defaultProps,
      mapHeight,
      mapWidth,
      handleItemSelection,
      handleFormValues,
      getAddresseDetails,
      handleShowMarker,
      mapRadius,
      showPolygon,
      zipCode,
      drawMode,
      onDrawComplete,
    },
    ref,
  ) => {
    const googleMapApiKey = process.env.REACT_APP_GOOGLE_API_KEY;
    const radius = mapRadius && getMeters(mapRadius);

    const [polygonCoordinates, setPolygonCoordinates] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const { isLoaded } = useJsApiLoader({
      id: "google-map-script",
      googleMapsApiKey: googleMapApiKey,
    });

    useEffect(() => {
      if (zipCode?.length > 0) {
        setIsLoading(true);
        fetchBoundaryCoordinates();
      } else {
        setPolygonCoordinates([]);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [zipCode]);

    const fetchBoundaryCoordinates = () => {
      const payload = zipCode.map((z) => z?.zipCode);
      getBoundaryCoordinates({ zipCode: payload })
        .then((response) => {
          const results = response?.result || [];
          if (response.errorCode === 0) {
            const coordinates = results.map((r) => [r.coordinates]);
            const zipValues = results.map((r) => ({
              zipCode: r.ZipCode,
              zipId: r.ZipId,
            }));
            handleFormValues({ zipIdValues: zipValues, focusOut: true });
            setPolygonCoordinates(coordinates);
          }
          setIsLoading(false);
        })
        .catch(() => setIsLoading(false));
    };

    const memoizedCenter = useMemo(
      () => [defaultProps?.center?.lng, defaultProps?.center?.lat],
      [defaultProps?.center],
    );

    return (
      <>
        {isLoading && <Loader />}
        {isLoaded && defaultProps?.center?.lat && (
          <MapBoxComponent
            ref={ref}
            center={memoizedCenter}
            radiusMiles={mapRadius}
            height={mapHeight}
            width={mapWidth}
            showPolygon={showPolygon}
            polygonCoordinates={polygonCoordinates}
            handleItemSelection={handleItemSelection}
            isEditable
            getDetailedAddress
            drawMode={drawMode}
            onDrawComplete={onDrawComplete}
          />
        )}
      </>
    );
  },
);

export default WantAdGoogleMap;
